
export const generalLabels = {
    next: "Next",
    back: "Back",
    submit: "Submit",
    continue: "Continue",
    cancel: "Cancel",
    close: "Close",
}

export const aboutLabels = {
    title: "About you",
    firstName: "First name",
    lastName: "Last name",
    birthdate: "Date of birth",
    pronouns: "Your pronouns (optional)",
    email: "Contact email",
    phone: "Phone number",
    nationality: "Nationality",
    residency: "Residency",
}

export const positionLabels = {
    title: "Your job on board",
    positions: "Position(s) on board",
    startDate: "Earliest possible starting date",
    moreInfoDate: "More information on your availability",
    cv: "Curriculum vitae",
    motivation: "Motivation",
    motivationPlaceholder: "Why do you want to join us? (at least three sentences)",
}

export const languagesLabels = {
    title: "Language skills",
    arabic: "Arabic",
    english: "English",
    french: "French",
    italian: "Italian",
    none: "None",
    professional: "Professional",
    additionalLanguages: "Additional languages (optional)",
}

export const certificatesLabels = {
    title: "Certificates and licences",
    basicSafety: "Basic safety certificate (STCW A-VI/1)",
    expiryDateBasicSafety: "Expiry date basic safety",
    medicalCertificate: "Medical certificate (for people with basic safety certificate)",
    expiryDateMedicalCertificate: "Expiry date medical certificate",
    rhibLicense: "RHIB license",
    additionalCertificates: "Certificate of proficiency for professional seafarer and other certificates",
    additionalCertificatesPlaceholder: "Please list all your additional certificates with the respective STCW reference and the expiry date, if applicable.",
}

const skillsLabels = {
    title: "Skills and experience",
    relevantSkills: "Relevant skills",
    otherRelevantSkills: "Other skills and experiences",
    medicalBackground: "Medical background",
    medicalBackgroundPlaceholder: "Do you have a medical background (e.g. first aid course, paramedic, medical doctor...)",
    dataprotection: "I consent to the storage of my data for a period of 6 months.",
    relevantSkillOptions: [
        'Cooking',
        'Welding',
        'Logistics',
        'Translation',
        'Craftsmanship',
        'Sailing',
    ]
}

const labels = {
    general: generalLabels,
    about: aboutLabels,
    position: positionLabels,
    languages: languagesLabels,
    certificates: certificatesLabels,
    skills: skillsLabels,
}

export default labels